import { useRef } from 'react';

export default function TextInputComponent({
    component,
    onUserInput,
    onUserInputComplete,
    defaultValues,
    compIndex
}) {
    const debounceTimeout = useRef();

    const handleChange = (e) => {
        const value = e.target.value;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            onUserInput(value);
        }, 1000); // 300ms debounce
    };

    return (
        <>
        <input
            tabIndex={compIndex + 1}
            className="form-control form-control-sm"
            placeholder={component.question}
            defaultValue={defaultValues}
            onChange={handleChange}
            onBlur={e => onUserInputComplete(e.target.value)}
        />
        </>
    );
}
